var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_c('ul',_vm._l((_vm.menu),function(item){return _c('li',{key:item.path},[_c('router-link',{attrs:{"active-class":"active","to":item.path,"tag":"a","exact":item.path === '/'}},[_vm._v(_vm._s(_vm.$t(item.title)))])],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }